import { api } from '@/lib/api';

const STORAGE_KEY = 'meridian.impersonation';

export interface ImpersonationTarget {
  id: string;
  displayName: string;
  email: string;
}

export function getImpersonation(): ImpersonationTarget | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ImpersonationTarget>;
    if (typeof parsed.id !== 'string' || !parsed.id) return null;
    return {
      id: parsed.id,
      displayName: parsed.displayName ?? '',
      email: parsed.email ?? '',
    };
  } catch {
    return null;
  }
}

export function startImpersonation(target: ImpersonationTarget): void {
  window.dispatchEvent(new Event('meridian:identity-changed'));
  localStorage.setItem(STORAGE_KEY, JSON.stringify(target));
}

export async function stopImpersonation(): Promise<void> {
  window.dispatchEvent(new Event('meridian:identity-changed'));
  try {
    await api.post('/me/impersonation/stop');
  } catch {
    // Stop is best-effort — clear locally regardless so the user is never stuck.
  }
  localStorage.removeItem(STORAGE_KEY);
  window.location.assign('/');
}
